import React, { useState } from 'react';
import { MBHover } from '@shared/components/hover';
import { MBTextCaption2 } from '@shared/components/typography';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export interface MBSeenByCountTextProps {
  /*
        Number of users
    */
  count: number;
  /*
        Text color. Default is normal gray.
    */
  color?: string;
}

export interface MBSeenWithoutCountTextProps {
  color?: string;
}

function MBSeenHoverLink({ content, color }: { content: string; color: string }) {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <MBHover
      hoverStyle={{ textDecoration: 'underline', color: Colors.v2.gray30 } as any}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <MBTextCaption2 color={isHovered ? Colors.v2.gray60 : color}>{content}</MBTextCaption2>
    </MBHover>
  );
}

export function MBSeenByCountText({ count, color = Colors.v2.gray30 }: MBSeenByCountTextProps) {
  return <MBSeenHoverLink content={i18n('chat.seenBy', { count })} color={color} />;
}

export function MBSeenWithoutCountText({ color = Colors.v2.gray30 }: MBSeenWithoutCountTextProps) {
  return <MBSeenHoverLink content={i18n('chat.seen')} color={color} />;
}
